import React, { useState } from "react";
import apiClient from "../../../../../api/apiClient";

const BulkEmailModal = ({ selectedIds, selectAllFiltered, filters, search, recipientCount, onClose, onSent }) => {
    const [form, setForm] = useState({ subject: "", body: "" });
    const [sending, setSending] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const set = (f) => (e) => setForm((p) => ({ ...p, [f]: e.target.value }));

    const closeOnBackdrop = (e) => {
        if (e.target === e.currentTarget && !sending) onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSending(true);
        try {
            const payload = { subject: form.subject, textBody: form.body };
            if (selectAllFiltered) {
                payload.filters = { ...filters };
                if (search) payload.filters.search = search;
            } else {
                payload.leadIds = [...selectedIds];
            }
            await apiClient.post("/admin/crm/email/send-leads", payload);
            setSuccess(true);
            setTimeout(() => { onSent?.(); }, 1500);
        } catch (err) {
            setError(err.response?.data?.error || err.response?.data?.errors?.[0]?.msg || "Failed to send emails");
        } finally {
            setSending(false);
        }
    };
    
    const count = recipientCount;
    const plural = count !== 1 ? "s" : "";

    return (
        <div className="crm-modal-overlay" onClick={closeOnBackdrop}>
            <div className="crm-modal">
                <div className="crm-modal__header">
                    <h2 className="crm-modal__title">✉ Email {count} Lead{plural}</h2>
                    <button className="crm-modal__close" onClick={onClose} disabled={sending}>×</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="crm-modal__body">
                        <div className="admin-form-group" style={{ marginBottom: 16 }}>
                            <label className="admin-form-label">Recipients</label>
                            <div style={{ fontSize: 13, color: "var(--color-text-secondary)", padding: "6px 0" }}>
                                {selectAllFiltered
                                    ? `All ${count} leads matching current filters`
                                    : `${count} selected lead${plural}`
                                }
                                {" "}— sent to email addresses only
                            </div>
                        </div>

                        {error && <div className="crm-email-banner crm-email-banner--error">{error}</div>}
                        {success && (
                            <div className="crm-email-banner crm-email-banner--success">
                                ✓ Emails sent to {count} recipient{plural}.
                            </div>
                        )}

                        <div className="admin-form-group" style={{ marginBottom: 16 }}>
                            <label className="admin-form-label">
                                Subject <span style={{ color: "#ef4444" }}>*</span>
                            </label>
                            <input
                                className="admin-form-input"
                                required
                                value={form.subject}
                                onChange={set("subject")}
                                maxLength={300}
                                placeholder="Email subject"
                                autoFocus
                                disabled={success}
                            />
                        </div>

                        <div className="admin-form-group">
                            <label className="admin-form-label">
                                Message <span style={{ color: "#ef4444" }}>*</span>
                            </label>
                            <textarea
                                className="admin-form-input"
                                required
                                rows={9}
                                value={form.body}
                                onChange={set("body")}
                                style={{ resize: "vertical", lineHeight: 1.6 }}
                                maxLength={50000}
                                placeholder="Write your message here…"
                                disabled={success}
                            />
                        </div>
                    </div>

                    <div className="crm-modal__footer">
                        <button type="button" className="admin-btn" onClick={onClose} disabled={sending}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="admin-btn admin-btn--primary"
                            disabled={sending || success}
                        >
                            {sending ? `Sending to ${count}…` : `Send to ${count} Lead${plural}`}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default BulkEmailModal;
